export const iconFontAwesomeMoneyBahtSign = (
	<i className="fa-solid fa-baht-sign"></i>
);
